export default __webpack_public_path__ + "static/media/screen10.61c500c3.svg";